import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';

type FormValidator = ((value: string | null) => boolean | string) | undefined;

export function validatorFactory(validators: FormValidator[]): FormValidator {
	return (value: string | null) => {
		let valid: boolean | string = true;

		for (const validator of validators) {
			if (!validator) {
				continue;
			}

			valid = validator(value);

			if (valid !== true) {
				break;
			}
		}

		return valid;
	};
}

export function validateRequired(value: string | null): boolean {
	// Seems to be the way of doing conditional validation in react-hook-form?
	// https://github.com/react-hook-form/react-hook-form/issues/1781#issuecomment-639256365
	if (value == null) return true;

	if (value.trim() != '') {
		return true;
	}

	return false;
}

export function validateKindaOkEmail(value: string | null): boolean {
	// Seems to be the way of doing conditional validation in react-hook-form?
	// https://github.com/react-hook-form/react-hook-form/issues/1781#issuecomment-639256365
	if (!value) return true;

	// It's intentionally not a "full email validation", it does not exist.
	// You cannot validate email addresses without being the provider of the email address, period.
	if (value.includes('@') && value.includes('.') && value.length >= 5) {
		return true;
	}

	return false;
}

export function validatePhoneNumber(value: string | null, countryCode: CountryCode): boolean {
	// Seems to be the way of doing conditional validation in react-hook-form?
	// https://github.com/react-hook-form/react-hook-form/issues/1781#issuecomment-639256365
	if (!value) return true;

	// TODO: SE should be read from the comp
	return isValidPhoneNumber(value, countryCode);
}
